<div class="user-management-page">
  <div class="users-header">
    <div>
      <h3>User Management</h3>
      <span>Manage TCA user access</span>
    </div>
    <button class="primary-btn" type="button" (click)="openCreateModal()">
      <i class="fas fa-user-plus"></i>
      New User
    </button>
  </div>

  <app-data-table
    [data]="users"
    [columns]="tableColumns"
    [paginator]="true"
    [rows]="10"
    [showCheckbox]="false"
    (onActionClick)="onTableActionClick($event)">
  </app-data-table>

  <div class="user-modal-overlay" *ngIf="showUserModal" (click)="closeUserModal()"></div>
  <div class="user-modal" *ngIf="showUserModal">
    <div class="modal-header">
      <h5>{{ modalMode === 'create' ? 'Create User' : 'Edit User' }}</h5>
      <button class="modal-close-btn" type="button" (click)="closeUserModal()">
        <i class="fas fa-times"></i>
      </button>
    </div>
    <div class="modal-body user-form-grid">
      <label>
        Full Name
        <input type="text" [(ngModel)]="userForm.fullName">
      </label>
      <label>
        Email <span>*</span>
        <input type="email" [(ngModel)]="userForm.email">
      </label>
      <label>
        Mobile
        <input type="text" [(ngModel)]="userForm.mobile">
      </label>
      <label>
        Role <span>*</span>
        <select [(ngModel)]="userForm.role">
          <option *ngFor="let role of roleOptions" [ngValue]="role.value">{{ role.label }}</option>
        </select>
      </label>
      <label class="toggle-row">
        <input type="checkbox" [(ngModel)]="userForm.isActive">
        Active
      </label>
      <label class="toggle-row">
        <input type="checkbox" [(ngModel)]="userForm.isEmailVerified">
        Email Verified
      </label>
      <label class="toggle-row">
        <input type="checkbox" [(ngModel)]="userForm.mustChangePassword">
        Must Change Password
      </label>
      <ng-container *ngIf="modalMode === 'create'">
        <label>
          Password <span>*</span>
          <div class="password-field">
            <input [type]="showPassword ? 'text' : 'password'" [(ngModel)]="userForm.password">
            <button type="button" (click)="togglePasswordVisibility()">
              <i class="fas" [class.fa-eye]="!showPassword" [class.fa-eye-slash]="showPassword"></i>
            </button>
          </div>
        </label>
        <label>
          Confirm Password <span>*</span>
          <div class="password-field">
            <input [type]="showConfirmPassword ? 'text' : 'password'" [(ngModel)]="userForm.confirmPassword">
            <button type="button" (click)="toggleConfirmPasswordVisibility()">
              <i class="fas" [class.fa-eye]="!showConfirmPassword" [class.fa-eye-slash]="showConfirmPassword"></i>
            </button>
          </div>
        </label>
      </ng-container>
    </div>
    <div class="modal-footer">
      <button class="secondary-btn" type="button" (click)="closeUserModal()">Cancel</button>
      <button class="primary-btn" type="button" (click)="saveUser()">Save</button>
    </div>
  </div>

  <div class="user-modal-overlay" *ngIf="showPasswordModal" (click)="closePasswordModal()"></div>
  <div class="user-modal password-modal" *ngIf="showPasswordModal">
    <div class="modal-header">
      <h5>Reset Password</h5>
      <button class="modal-close-btn" type="button" (click)="closePasswordModal()">
        <i class="fas fa-times"></i>
      </button>
    </div>
    <div class="modal-body user-form-grid single-column">
      <label>
        Password <span>*</span>
        <div class="password-field">
          <input [type]="showPassword ? 'text' : 'password'" [(ngModel)]="passwordForm.password">
          <button type="button" (click)="togglePasswordVisibility()">
            <i class="fas" [class.fa-eye]="!showPassword" [class.fa-eye-slash]="showPassword"></i>
          </button>
        </div>
      </label>
      <label>
        Confirm Password <span>*</span>
        <div class="password-field">
          <input [type]="showConfirmPassword ? 'text' : 'password'" [(ngModel)]="passwordForm.confirmPassword">
          <button type="button" (click)="toggleConfirmPasswordVisibility()">
            <i class="fas" [class.fa-eye]="!showConfirmPassword" [class.fa-eye-slash]="showConfirmPassword"></i>
          </button>
        </div>
      </label>
      <label class="toggle-row">
        <input type="checkbox" [(ngModel)]="passwordForm.mustChangePassword">
        Must Change Password
      </label>
    </div>
    <div class="modal-footer">
      <button class="secondary-btn" type="button" (click)="closePasswordModal()">Cancel</button>
      <button class="primary-btn" type="button" (click)="resetPassword()">Reset</button>
    </div>
  </div>
</div>
